import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  listActivities,
  adminListActivities,
  createActivity,
  updateActivity,
  deactivateActivity,
} from "../api/activities";
import type { ActivityCatalogEntry } from "../api/types";

export function useActivityCatalog() {
  return useQuery({
    queryKey: ["tawa", "activities"],
    queryFn: listActivities,
    staleTime: 5 * 60_000,
  });
}

export function useAdminActivities() {
  return useQuery({
    queryKey: ["tawa", "admin", "activities"],
    queryFn: adminListActivities,
    staleTime: 30_000,
  });
}

export function useCreateActivity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (entry: Omit<ActivityCatalogEntry, "id" | "archived_at">) =>
      createActivity(entry),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["tawa", "admin", "activities"] });
      void qc.invalidateQueries({ queryKey: ["tawa", "activities"] });
    },
  });
}

export function useUpdateActivity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      ...entry
    }: Partial<ActivityCatalogEntry> & { id: string }) =>
      updateActivity(id, entry),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["tawa", "admin", "activities"] });
      void qc.invalidateQueries({ queryKey: ["tawa", "activities"] });
    },
  });
}

export function useArchiveActivity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deactivateActivity(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["tawa", "admin", "activities"] });
      void qc.invalidateQueries({ queryKey: ["tawa", "activities"] });
    },
  });
}
